import { AxiosResponse } from 'axios'

import { ApiErrorBase } from 'api/core/ApiErrorBase'
import { ValidationExceptionJSON } from 'api/domain/app'

export class ValidationException extends ApiErrorBase {
  constructor({ detail }: ValidationExceptionJSON | { detail: any }, { status }: AxiosResponse) {
    const error = Array.isArray(detail) ? detail[0] : detail
    if (typeof error === 'string') {
      super({
        message: error,
        statusCode: status,
      })
    } else if (typeof error === 'object') {
      super({
        message: error.msg,
        type: error.type,
        statusCode: status,
      })
    } else {
      super({
        message: 'Unhandled API error',
        statusCode: status,
      })
    }
  }
}
